import React from 'react'
import { Outlet } from 'react-router-dom';


const ForecastStatMngPage = () => {
    return (
        <Outlet />
    )
}

export default ForecastStatMngPage